import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import useRolePermissions from 'hooks/useRolePermissions'
import { LiveCallsPlusIcon } from 'components/common/icons'
import PrimaryButton from 'components/common/buttons/PrimaryButton'
import LiveCallModal from './LiveCallModal'
import { trackEvent } from 'utils/analyticsUtils'
import { useSelector } from 'react-redux'
import { isSafari } from 'react-device-detect'
import GrantPermissionsDialog from 'components/Patients/ScanReview/GrantPermissionsDialog'

const useStyles = makeStyles(theme => ({
  liveCallsRoot: {
    padding: 20,
    height: '100%',
    backgroundColor: 'white'
  },
  instantMeetingBtn: {
    color: 'var(--text-color-16)',
    border: '1px solid var(--text-color-16)'
  },
  newCallDisabled: {
    opacity: 0.5
  }
}))

const LiveCalls = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { permissions } = useRolePermissions()
  const { patient } = useSelector(state => state.patientsReducer)
  const treatment = useSelector(state => state.treatmentReducer.treatment)
  const [grantPermissionsDialog, setGrantPermissionsDialog] = useState({ open: false, permissionType: null })

  const [isLiveCallModalOpen, setIsLiveCallModalOpen] = useState(false)

  const isPatientDisabled = useMemo(
    () => !patient.user?.isActive || treatment?.currentStatus?.statusKey?.includes('transferred'),
    [patient.user?.isActive, treatment?.currentStatus?.statusKey]
  )

  const handleCloseSafariNotSupportedModal = () => {
    setGrantPermissionsDialog({ open: false })
    trackEvent('Live calls - Safari not supported modal closed')
  }

  const handleStartInstantMeeting = useCallback(() => {
    if (isSafari) {
      trackEvent('Live calls - Attempted to start an instant live call on Safari')
      setGrantPermissionsDialog({ open: true, permissionType: 'safari' })
    } else {
      trackEvent('Live calls - Start instant meeting clicked')
      setIsLiveCallModalOpen(true)
    }
  }, [])

  return (
    <>
      <GrantPermissionsDialog
        id="grant-permissions-dialog"
        open={grantPermissionsDialog.open}
        permissionType={grantPermissionsDialog.permissionType}
        onClose={handleCloseSafariNotSupportedModal}
      />
      <Grid container direction="column" wrap="nowrap" className={classes.liveCallsRoot}>
        <Grid item xs={12}>
          <DazzedParagraph14 bold color="var(--text-color-18)">
            {t('pages.patients.patientSwitchableView.liveCalls.title')}
          </DazzedParagraph14>
        </Grid>
        <Grid item xs={12} style={{ height: '100%' }}>
          <Grid container direction="column" alignItems="center" justifyContent="center">
            <Grid item>
              <PrimaryButton
                id="live-calls-instant-meeting-button"
                variant="outlined"
                fontWeight={500}
                width={260}
                height={50}
                className={`${classes.instantMeetingBtn} ${
                  isPatientDisabled || !permissions.liveCalls.startInstantLiveCall ? classes.newCallDisabled : ''
                }`}
                icon={<LiveCallsPlusIcon />}
                label={t('pages.patients.patientSwitchableView.liveCalls.buttons.instantMeetingLabel')}
                disabled={isPatientDisabled || !permissions.liveCalls.startInstantLiveCall}
                onClick={handleStartInstantMeeting}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {isLiveCallModalOpen && <LiveCallModal isOpen={isLiveCallModalOpen} setIsOpen={setIsLiveCallModalOpen} />}
    </>
  )
}

export default LiveCalls
